import { Component, OnInit, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { ApiService } from '../services/api.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  changeAvatarBoolean: boolean = false;
  chosenAvatar: any;
  UserSpecificData: any;
  showCeckOutUserModal: boolean;
  enableCheckOutButton: boolean = false;
  userQueryParams: string;
  data: any;
  winnerString: string;
  avatarPicture: any;
  apiUrl: any;

  getSpecificUserQueryParams: any = ['visits?userId=','users?_id='];

  deleteVisitorId:string;

  public users: any;
  public userTableRows: any = [];
  public userTempRows: any = [];
  public userTableColumns: any = [];
  public usersCount: number = 0;
  public selected: any = [];
  public globalError: boolean = false;
  public sideBarStatus: string = 'show-sidebar';
  public modalStatus: string = 'hide-modal';
  public imageStatus: string;
  public editUserForm: any = [];
  public ownImagePicture: string;
  public genders:any[]=[];
  public municipalities:any;
  public selectedMunicipality:any;
  public selectedGender: any;
  public selectedDateOfBirth: any;
  public loggedInUserEmail: string = localStorage.getItem('email');
  public winner:string = 'vinnaren är: '
  public showLoadingSpinner: boolean = true;
  public showWinnerUserModal: boolean = false;
  public showDeleteUserModal: boolean = false;
  public disableWinnerButton: boolean = false;
  public showParentalConsentUserModal: boolean = false;

  NumberOfAvatars: any;
  imagesArray: any[]=[]; // init this value with your images

  @ViewChild('datetemplate') datetemplate: TemplateRef<any>;
  @ViewChild('editemplate') editemplate: TemplateRef<any>;
  @ViewChild(DatatableComponent) userTable: DatatableComponent;

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private router: Router) {
    this.editUserForm = this.formBuilder.group({
      _row_id: [''],
      _id: [''],
      userName: ['', <any>Validators.required],
      avatarImage:[''],
      firstName: ['', <any>Validators.required],
      lastName: ['', <any>Validators.required],
      gender: ['', <any>Validators.required],
      dateOfBirth:['', <any>Validators.required],
      ownImage:'',
      address: this.formBuilder.group({
        name:'',
        address: '',
        zip: '',
        postalZone:''
      }),
      mobilePhone:'',
      homePhone:'',
      municipality:['', <any>Validators.required],
      municipalityAccess:[true],
      parentalConsent: Boolean

    });
    this.apiUrl = this.apiService.getApiUrl();
    this.getMunicipalities();
    this.getGenders();
    this.getAvatars();
  }

  ngOnInit() {
    this.getUsers();
    this.globalError = false;
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    this.router.navigateByUrl('login');
  }

  // Keyboard klick events
  @HostListener('window:keydown', ['$event'])
  keyboardInput(event: KeyboardEvent) {
    // If Ecs key is clicked and modal is visible hide the modal
    if(event.which == 27 && this.modalStatus == 'show-modal') {
      this.hideModals();
    }
  }
  //gets user visits to enable checkout button in editUserForm
  enableCheckOut(userId) {
    var today = new Date();
    today.setHours(0,0,0,0);
    var tomorrow = new Date();
    tomorrow.setHours(24,0,0,0);
    this.apiService.get('visits?userId='+userId+'&dateTime[$gt]='+today+'&dateTime[$lt]='+tomorrow).then((response:any) => {
      if(response.data.length===1){
        this.enableCheckOutButton=true;
        this.deleteVisitorId=response.data['0']._id;
      }
      else{
        this.enableCheckOutButton=false;
      }
    }).catch((err) => {

    });
  }

  // Get all users and append the to the ngx swimlane data table
  getUsers() {
    this.apiService.get('users/?$limit=100000&active=true').then((response:any) => {
      this.usersCount = response.data.length;

      if(this.checkIfMobileDevice() == true) {
        this.userTableColumns = [
          {name: 'Användarnamn', prop: 'userName'},
          {name: 'Förnamn', prop: 'firstName'},
          {name: 'Efternamn', prop: 'lastName'},
          {name: 'Ändra', cellTemplate: this.editemplate}
        ];
      } else {
        this.userTableColumns = [
          {name: 'Användarnamn', prop: 'userName'},
          {name: 'Förnamn', prop: 'firstName'},
          {name: 'Efternamn', prop: 'lastName'},
          {name: 'Födelsetid', prop: 'dateOfBirth', cellTemplate: this.datetemplate},
          {name: 'Kommun', prop: 'municipality.municipality'},
          {name: 'Ändra', cellTemplate: this.editemplate}
        ];
      }

      this.userTableRows = response.data;
      this.userTempRows = response.data;

      this.showLoadingSpinner = false;
      this.globalError = false;
    }).catch((err) => {
      this.globalError = true;
    });
  }

  // Get the municipalities and append them to the municipalities select box in the edit user form
  getMunicipalities() {
    this.apiService.get('municipalities').then((response:any) => {
      this.municipalities = response.data;
    }).catch((err) => {
    });
  }

  // Get the genders and append them to the genders select box in the edit user form
  getGenders() {
    this.apiService.get('genders').then((response:any) => {
      this.genders= response.data;
      for (let i = 0; i < this.genders.length; i++) {
        if(this.genders[i].gender == 'other') {
          this.genders[i].gender = 'Ospecificerat';
        } else if(this.genders[i].gender == 'male') {
          this.genders[i].gender = 'Man';
        } else if(this.genders[i].gender == 'female') {
          this.genders[i].gender = 'Kvinna';
        }
      }
    }).catch((err) => {
    });
  }
  // Get the avatars and append them to the avatars select box in the edit user form
  getAvatars(){
    this.apiService.get('avatars').then((response:any)=>{
      this.NumberOfAvatars = response.numberOfAvatars;
      for(var index = 0; index <= this.NumberOfAvatars ; index++ ){
        this.imagesArray.push(this.apiUrl+'/avatar/'+index+'.png');
      }
    })
  }
  changeAvatar(){
    this.changeAvatarBoolean = !this.changeAvatarBoolean;
  }
  chooseAvatar(index,img){
    this.chosenAvatar = index;
  }

  // Parse date function
  parseDate(date) {
    var dateObj = new Date(date);
    return ('0' + dateObj.getDate()).slice(-2) + '.' + ('0' + (dateObj.getMonth()+1)).slice(-2) + '.' + dateObj.getFullYear();
  }

  // Open the edit user modal
  openUserModal(user) {
    window.scrollTo(0,0);
    this.imageStatus = '';
    this.enableCheckOut(user._id)
    // Update the edit form with user info
    this.editUserForm.controls['_row_id'].setValue(user.$$index);
    this.editUserForm.controls['_id'].setValue(user._id);

    if(user.ownImage.length) {
      this.editUserForm.controls['ownImage'].setValue(user.ownImage);
      this.ownImagePicture = user.ownImage;
    } else {
      this.editUserForm.controls['ownImage'].setValue('');
      this.ownImagePicture = '';
    }
    if(user.avatarImage >= 0){
      this.editUserForm.controls['avatarImage'].setValue(user.avatarImage)
      this.avatarPicture = user.avatarImage;
    }
    else {
      this.editUserForm.controls['avatarImage'].setValue('0');
      this.avatarPicture = 0;
    }

    this.selectedMunicipality = user.municipality._id;
    this.selectedGender = user.gender._id;
    this.selectedDateOfBirth = user.dateOfBirth;


    this.editUserForm.controls['userName'].setValue(user.userName);
    this.editUserForm.controls['firstName'].setValue(user.firstName);
    this.editUserForm.controls['lastName'].setValue(user.lastName);
    this.editUserForm.controls.address.controls['address'].setValue(user.address[0].address);
    this.editUserForm.controls.address.controls['zip'].setValue(user.address[0].zip);
    this.editUserForm.controls.address.controls['postalZone'].setValue(user.address[0].postalZone);
    this.editUserForm.controls['mobilePhone'].setValue(user.phone[1].number);
    this.editUserForm.controls['homePhone'].setValue(user.phone[0].number);

    this.editUserForm.controls['parentalConsent'].setValue(user.parentalConsent)

    this.modalStatus = 'show-modal';

  }

  // Submit the edit user form
  submitEditUserForm() {
    let rowId = this.editUserForm.value._row_id;
    let userId = this.editUserForm.value._id;
    let dateOfBirthFormatted = new Date(this.editUserForm.value.dateOfBirth).toISOString();

    let body = {
        'userName': this.editUserForm.value.userName,
        'avatarImage': this.chosenAvatar,
        'firstName': this.editUserForm.value.firstName,
        'lastName':  this.editUserForm.value.lastName,
        'gender':  this.editUserForm.value.gender,
        'dateOfBirth':  dateOfBirthFormatted,
        'ownImage':this.editUserForm.value.ownImage,
        'address': [{
          'name': 'homeAddress',
          'address': this.editUserForm.value.address.address,
          'zip': this.editUserForm.value.address.zip,
          'postalZone': this.editUserForm.value.address.postalZone
        }],
        'phone':[
          {'name': 'homePhone', 'number': this.editUserForm.value.homePhone},
          {'name': 'mobilePhone', 'number': this.editUserForm.value.mobilePhone}
          ],
        'municipality': this.editUserForm.value.municipality,
        'municipalityAccess': this.editUserForm.value.municipalityAccess

    };
    if(this.editUserForm.valid) {
      this.apiService.patch('users/' + userId, body).then((response:any) => {

        // Update the correct row in the ngx datatables
        this.updateTablerowsAfterpatch(rowId,response);
        this.hideModals();
        this.globalError = false;
      }).catch((err) => {
        this.globalError = true;
      });
    } else {
      alert('form not valid')
    }
  }
  updateTablerowsAfterpatch(rowId,response){
        this.userTableRows[rowId].userName = response.userName;
        this.userTableRows[rowId].firstName = response.firstName;
        this.userTableRows[rowId].lastName = response.lastName;
        this.userTableRows[rowId].dateOfBirth = (response.dateOfBirth)
        this.userTableRows[rowId].municipality = response.municipality;
        this.userTableRows[rowId].municipalityAccess = response.municipalityAccess;
        this.userTableRows[rowId].parentalConsent = response.parentalConsent;
        this.userTableRows[rowId].address = [{
          'name': 'homeAddress',
          'address': response.address[0].address,
          'zip': response.address[0].zip,
          'postalZone': response.address[0].postalZone
        }]
        this.userTableRows[rowId].avatarImage = response.avatarImage;
        this.userTableRows[rowId].ownImage = response.ownImage;
        this.userTableRows[rowId].phone = [
          {'name': 'homePhone', 'number': response.phone[0].number},
          {'name': 'mobilePhone', 'number': response.phone[0].number}
          ];
  }

  // Hide modals function
  hideModals() {
    this.modalStatus = 'hide-modal';
  }

  // Delete own image function
  deleteOwnImage() {
    this.imageStatus = 'deleted-image';
    this.editUserForm.controls['ownImage'].setValue('');
  }
  goToPage(pageIndex, event) {
  event.preventDefault();
  console.log(pageIndex);
}
  filterUsers(event) {
    const val = event.target.value;

    var keywords = val.toLowerCase().replace(/\s/g,'');

    // filter our data
    const temp = this.userTempRows.filter(function(row) {
      return row.firstName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
      row.lastName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||row.userName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
      (row.lastName.toLowerCase() + row.firstName.toLowerCase().split(' ')[0]).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      (row.firstName.toLowerCase().split(' ')[0] + row.lastName.toLowerCase()).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      (row.userName.toLowerCase().split(' ')[0] + row.lastName.toLowerCase()).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      (row.lastName.toLowerCase() + row.firstName.toLowerCase()).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      (row.firstName.toLowerCase() + row.lastName.toLowerCase()).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      (row.userName.toLowerCase() + row.lastName.toLowerCase()).replace(/\s/g,'').indexOf(keywords) !== -1 ||
      !val;
    });

    // update the rows
    this.userTableRows = temp;
    // Whenever the filter changes, always go back to the first page
    this.userTable.offset = 0;
  }
  deleteUser(){
    var today = new Date();
    today.setHours(0,0,0,0);
    var tomorrow = new Date();
    tomorrow.setHours(24,0,0,0);
        this.apiService.delete('users/'+this.editUserForm.value._id).then((response:any)=>{
        }).catch((err) => {
          alert('kunde inte radera användare')
      });
    this.userTableRows.splice(this.userTableRows[this.editUserForm.value._row_id].$$index,1)
    this.hideModals();
  }

  parentalConsent(){
    var rowId = this.editUserForm.value._row_id
    var body = {
      parentalConsent : true
    }
    this.apiService.patch('users/'+this.editUserForm.value._id,body).then((response:any)=>{
      this.updateTablerowsAfterpatch(rowId,response)
    }).catch((err)=>{
      alert("kunde inte spara godkännandet")
    })
    this.hideModals();
    
  }

  // Find new winner
  findNewWinner(){
    this.showWinnerUserModal=true;
    this.showDeleteUserModal=false;
    this.showCeckOutUserModal=false;
    this.showParentalConsentUserModal=false;


    this.apiService.post('winners').then((response:any)=>{
      if(response.message){
        this.winnerString = 'Omöjligt att dra en ny vinnare. Samtliga personer som är inloggade har vunnit.';
      } else {
        this.winnerString = this.winner.concat(response.userName.userName , ' Förnamn: ' ,response.userName.firstName);
      }
    })
  }
  triggerDeleteModal(){
    this.showWinnerUserModal = false;
    this.showDeleteUserModal = true;
    this.showCeckOutUserModal = false;
    this.showParentalConsentUserModal = false;
    
  }
  showCheckoutModal(){
    this.showCeckOutUserModal = true;
    this.showDeleteUserModal = false;
    this.showWinnerUserModal = false;
    this.showParentalConsentUserModal = false;
    
  }
  showParentalConsentModal(){
    this.showCeckOutUserModal = false;
    this.showDeleteUserModal = false;
    this.showWinnerUserModal = false;
    this.showParentalConsentUserModal = true;
  }


  checkOutUser(){
    this.apiService.delete('visits?_id='+this.deleteVisitorId).then((response:any)=>{
      this.deleteVisitorId = "";
      this.enableCheckOutButton = false;
      this.hideModals();
    }).catch((err) => {
    });
  }
  getUserSpecificData(){
    this.getSpecificUserQueryParams.forEach(element => {
      this.apiService.getCsvFormat(element +this.editUserForm.value._id).then((response:any) => {
        this.UserSpecificData = response;

        var a = document.createElement("a");
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        var blob = new Blob([this.UserSpecificData._body], { type: 'text/csv' });
        var url= window.URL.createObjectURL(blob);
        a.href = url;
        if(element=='visits?userId='){
          a.download = this.editUserForm.value.userName +' Besök, nerladdat:' + new Date().toJSON().slice(0,10).replace(/-/g,'/') +  '.csv';
        }
        if(element=='users?_id='){
          a.download = this.editUserForm.value.userName +'s användarinformation, nerladdat:' + new Date().toJSON().slice(0,10).replace(/-/g,'/') +  '.csv';
        }
        a.click();

    }).catch((err) => {
      if(err.status==404){
        alert('ingen info går att finna')
      }
      else{
        this.globalError = true;
      }
    });
    });

  }

  // Toggle sidebar
  toggleSidebar() {
    this.sideBarStatus = (this.sideBarStatus == 'hide-sidebar' ? 'show-sidebar' : 'hide-sidebar');
  }

  checkIfMobileDevice() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      return true;
    } else {
      return false;
    }
  }

  onSelect({ selected }) {
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts